/*eslint-env jquery*/
import React, { Component } from 'react'
import { attachmentsService } from '../../_services/attachments.service'
import { toastr } from 'react-redux-toastr'
import { AiOutlineLoading } from "react-icons/ai"
import { FiCheckSquare, FiSquare } from "react-icons/fi"
import imageCompression from 'browser-image-compression';
import { config } from '../../config'
const base_url = config.uploadsUrl


class PicUploader3 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      statusLoading: false,
      value: this.props.value
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value && nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value, loading: false });
    }
  }

  handleImageUpload = async (event) => {
    this.setState({ loading: true });
    var a = this;
    var imageFile = event.target.files[0];
    // // console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
    // // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

    var options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    imageCompression(imageFile, options)
      .then(function (compressedFile) {
        // // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
        // // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

        // const downloadLink = URL.createObjectURL(compressedFile)
        a.uploadToServer(compressedFile);
        // // console.log(compressedFile);

        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        // console.log(error.message);

        this.setState({ loading: false });
      });
  }


  uploadToServer = async (blob) => {

    let file = new File([blob], blob.name);

    // e.preventDefault();
    //Generate Preview Image
    // let files = Array.from(e.target.files);
    // let file = e.target.files[0];
    if (file) {
      this.setState({ loading: true });
      if (file.size > (1024 * 1024 * 3)) {
        toastr.error('حجم تصویر نباید بیشتر از 3 مگابایت باشد');
        this.setState({ loading: false });
      } else if (file.name.split('.').pop().toUpperCase() !== 'JPG' && file.name.split('.').pop().toUpperCase() !== 'JPEG' && file.name.split('.').pop().toUpperCase() !== 'PNG') {
        toastr.error('فقط تصاویر jpg و png پشتیبانی می شود');
        this.setState({ loading: false });
      } else {

        // var img = new Image();
        // img.onload = function() {
        //   // console.log("This image has width "+this.width+"px and height "+this.height+"px.");
        // }
        // img.src = file;

        // this.props.onChange(file)

        const formData = new FormData();
        formData.append('file', file);
        // formData.append('width', '');
        // formData.append('height', '');
        // formData.append('needCompresstion', false);
        // // console.log(file);


        attachmentsService.UploadSellerFormImage(formData)
          .then((res) => {

            this.setState({ value: res.data, loading: false });

            toastr.success("تصویر [" + this.props.label + "] با موفقیت آپلود شد")

            this.props.onChange(res.data);

            let reader = new FileReader();

          })
          .catch((error) => {
            // console.log(error)
            this.setState({ loading: false });
            toastr.warning("مشکلی پیش آمد. لطفا دوباره سعی کنید.")
          });
      }
    }

  }



  _handleImageChange = e => {

    e.preventDefault();

    this.setState({ loading: true });

    let file = e.target.files[0];

    if (file) {
      if (file.size > 1024 * 1024 * 2) {

        toastr.error('حجم تصویر نباید بیشتر از 150 کیلوبایت باشد');
        this.setState({ loading: false });

      } else if (file.name.split('.').pop().toUpperCase() !== 'JPG' &&
        file.name.split('.').pop().toUpperCase() !== 'JPEG' &&
        file.name.split('.').pop().toUpperCase() !== 'PNG') {

        toastr.error('فرمت فایل پشتیبانی نمی شود');
        this.setState({ loading: false });

      } else {


        const formData = new FormData();
        formData.append('file', file);

        attachmentsService.upload(formData)
          .then((res) => {
            console.log(res);
            this.setState({ value: res.data, loading: false });

            toastr.success("تصویر [" + this.props.label + "] با موفقیت آپلود شد")

            this.props.onChange(res.data);

          })
          .catch((error) => {

            // console.log(error)
            this.setState({ loading: false })
            toastr.warning("مشکلی پیش آمد. لطفا دوباره سعی کنید.")

          });
      }
    } else {
      this.setState({ loading: false });
    }
  }



  _handleClick = (e) => {
    var inputField = this.refs.fileField;
    inputField.click()
  }

  render() {
    const { value, loading, statusLoading } = this.state;
    const { className, label } = this.props;

    return (
      <div className={className ? className + " file-area-new" : " file-area-new"}>
        <input ref="fileField" type="file" accept='image/*' onChange={this.handleImageUpload} />
        <div className="file-dummy">
          {value &&
            <div className="top-label">{label}</div>
          }
          {value ?
            (<div className={"success " + (!value ? "hidden" : "")}>
              {!loading ?
                <img
                  src={base_url + value}
                  onLoad={() => this.setState({ loading: false })}
                  alt=""
                  onError={() => console.log("eee")}
                  className={"previewImage "} />
                : ''}
            </div>)
            :
            (<div className={"default "}><span>
              {!loading && label}
            </span>
            </div>)
          }
          <a className="btn btn-primary btn-lg uploadBtn" onClick={e => this._handleClick(e)}>انتخاب فایل</a>
        </div>
        {loading &&
          (<div className="indicator" style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0 }}>
            <div className="PicLoader" >
              <AiOutlineLoading className="mdi-spin main-color" size={40} color="#4D64EA" />
            </div>
          </div>)}
      </div>
    );
  }
}
export default PicUploader3;
